// Site statuses
const siteStatusEnum = Object.freeze({
  draft: 'Sites_Status_Draft',
  live: 'Sites_Status_Live'
  // ended: 'Sites_Status_Ended',
  // disabled: 'Sites_Status_Disabled'
})

export { siteStatusEnum }



// WEBPACK FOOTER //
// ./src/modules/sites/enum/SiteStatusEnum.js